<template>
  <div class="border-solid bg-whiteOverride p-lg border-border border-1 mb-xxl">
    <div class="flex flex-wrap items-baseline">
      <div class="flex items-center">
        <slot name="icon" />
        <h1 class="mb-0 font-medium text-black text-24 mr-base">
          <slot name="title" />
        </h1>
      </div>
      <a
        v-if="helpLink"
        :href="helpLink"
        :aria-label="$t('bulkSend.relatedHelpDocument')"
        target="_blank"
        class="font-normal text-placeholderGray font-body text-12 mt-sm"
        data-test="help-link"
        :data-ec="stepNavigationButtonDataEc"
        data-et="help_link"
      >
        {{ $t('bulkSend.whatsThis') }}
        <ArrowUpRightFromSquareIcon class="ml-xs" />
      </a>
    </div>

    <hr class="mb-lg" />

    <slot />

    <StepsNavigation
      v-if="showNavigation"
      :on-back="onBack"
      :on-save="onSave"
      :is-busy-on-save="isBusyOnSave"
      :on-next="onNext"
      :is-busy-on-next="isBusyOnNext"
      :is-disabled="isDisabled"
      :show-next="showNext"
      :button-data-ec="stepNavigationButtonDataEc"
    />

    <TWModal
      v-if="uhoh"
      :title="$t('bulkSend.uhoh.title')"
      :show="!!uhoh"
      :loading="false"
      @close="closeUhoh"
    >
      <template v-slot:content>
        {{ $t(`bulkSend.uhoh.${uhoh}.changed`) }}
      </template>
      <template v-slot:controls>
        <ButtonLink :to="uhohRoute">
          {{ $t(`bulkSend.uhoh.${uhoh}.select`) }}
        </ButtonLink>
      </template>
    </TWModal>
  </div>
</template>

<script>
import StepsNavigation from '@/components/ui/bulkSend/StepsNavigation.vue';
import ButtonLink from '@/components/library/links/ButtonLink.vue';
import TWModal from '@/components/tailwind/Modal.vue';
import { ArrowUpRightFromSquareIcon } from '@/components/icons/fontIcons';

export default {
  name: 'StepLayout',
  components: {
    ButtonLink,
    StepsNavigation,
    TWModal,
    ArrowUpRightFromSquareIcon,
  },
  props: {
    helpLink: {
      type: String,
    },
    onBack: {
      type: Function,
      required: false,
    },
    onSave: {
      type: [Function, Boolean],
      required: false,
      default: undefined,
    },
    isBusyOnSave: {
      type: Boolean,
      required: false,
      default: false,
    },
    onNext: {
      type: [Function, Boolean],
      required: false,
    },
    isBusyOnNext: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    showNavigation: {
      type: Boolean,
      required: false,
      default: true,
    },
    showNext: {
      type: Boolean,
      required: false,
      default: true,
    },
    uhoh: {
      type: String,
      required: false,
    },
    closeUhoh: {
      type: Function,
      required: false,
    },
    uhohRoute: {
      type: Object,
      required: false,
    },
    stepNavigationButtonDataEc: {
      type: String,
      required: true,
    },
  },
};
</script>
